import * as React from 'react';
import * as styles from './slonoTopHeader.css';
import { ArmorIcon } from './ArmorIcon';
import { mergeStyles } from '@cian/utils';
import { UserTrustLevel } from '../../types/offer';
import { OwnerBadge, TTooltipVerifyWay } from '@cian/owner-badge-component';

export interface ISlonoTopHeader {
  agentAvatarUrl?: string | null;
  isPro?: boolean;
  name?: string;
  isFromBuilder: boolean;
  isFromSeller: boolean;
  userTrustLevel: UserTrustLevel | void;
  isByHomeOwner: boolean;
  isHomeownerVerified: boolean;
  verifyWay: TTooltipVerifyWay | undefined;

  onClick(e: React.MouseEvent): void;
}

export const SlonoTopHeader = (props: ISlonoTopHeader) => {

  const {
    agentAvatarUrl,
    isPro,
    name,
    isFromBuilder,
    isFromSeller,
    userTrustLevel,
    isByHomeOwner,
    isHomeownerVerified,
    verifyWay,
    onClick,
  } = props;

  return (
    <div className={ styles['slono-top_header'] } onClick={ onClick }>

      {
        agentAvatarUrl &&
        <div className={ styles['avatar'] }>
          <img src={ agentAvatarUrl }/>
        </div>
      }

      <span className={ styles['name'] }>{ name }</span>

      <div className={ styles['badge-container'] }>

        {
          userTrustLevel === 'involved' &&
          <div className={ styles['badge'] }>
            <ArmorIcon/>
          </div>
        }

        {
          isPro && !(isFromBuilder || isFromSeller) &&
          <div { ...mergeStyles([
            styles['badge'],
            styles['pro-badge'],
          ]) }>
            <span>PRO</span>
          </div>
        }

        {
          isFromBuilder &&
          <div
            { ...mergeStyles([
              styles['badge'],
              styles['text-badge'],
            ]) }
          >
            Застройщик
          </div>
        }

        {
          !isFromBuilder && isFromSeller &&
          <div
            { ...mergeStyles([
              styles['badge'],
              styles['text-badge'],
            ]) }
          >
            Представитель застройщика
          </div>
        }

        {
          isByHomeOwner &&
          <OwnerBadge isVerified={ isHomeownerVerified } verifyWay={ verifyWay }/>
        }

      </div>
    </div>
  );
};
